import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class ProvidesContexts extends BaseRootOption {
  static userInterfaceComponent = () => {
    return {
      useCustomLabel: true,
      useVerticalOrientation: true,
      label: "Provides Contexts",
      component: inspectorTools.PROVIDES_CONTEXTS,
    };
  };

  static defaultValue = {};
}
